import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Import.svg?component
var Import_exports = /* @__PURE__ */ __exportAll({
	default: () => Import_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
		createElementVNode("path", { d: "M12 10.67v7.98M14.66 16 12 18.64 9.34 16" }, null, -1),
		createElementVNode("path", { d: "M3.35 7.34h17.3s1.33 0 1.33 1.33v11.98s0 1.33-1.33 1.33H3.35s-1.33 0-1.33-1.33V8.67s0-1.33 1.33-1.33" }, null, -1),
		createElementVNode("path", { d: "m2.2 8 2.13-5.19a1.33 1.33 0 0 1 1.22-.79h12.9a1.33 1.33 0 0 1 1.22.8l2.08 5.1M12 7.34V2.02" }, null, -1)
	])]);
}
var Import_default = { render: render$1 };
//#endregion
export { Import_exports, Import_default as default, render$1 as render };

//# sourceMappingURL=Import.svg.virtual.js.map